/**
 * Cuándo la ventana debe seguir al final durante un turno en streaming.
 *
 * La regla, en una frase: **se sigue el final mientras no haya nada que leer**.
 *
 * Por qué. El modelo escribe más rápido de lo que una persona lee, así que perseguir el
 * final mientras llega texto significa mover el párrafo que el usuario está leyendo y
 * enseñarle líneas que aún no ha alcanzado. Anclar en cambio el principio de la respuesta
 * —dejar de seguir en cuanto aparece la primera letra— le deja leer a su ritmo mientras el
 * resto se acumula debajo. Es lo que hace Claude, y con respuestas como las del Experto
 * (10.982 caracteres en una sola vuelta, medido en PROD) la diferencia es grande.
 *
 * Pero en Flock hay algo que ahí no existe: **el indicador de actividad vive al final de la
 * burbuja** — «✦ Ejecutando set_action_cards», su cronómetro, el loader de herramientas.
 * Mientras no hay texto, eso es lo único que el usuario puede mirar para saber que algo pasa,
 * y tiene que estar a la vista. De ahí la regla: seguir mientras solo hay actividad, soltar
 * en cuanto hay letra.
 *
 * El anclaje sale gratis: como veníamos siguiendo el loader, cuando llega el primer token la
 * vista ya está justo donde empieza la burbuja. No hace falta medir posiciones ni tener una
 * referencia al nodo del mensaje.
 *
 * Vive aquí, y no en cada consumidor, porque el chat principal y el chat modular han ido
 * divergiendo en cosas así — el indicador duplicado y el scroll que no seguía en el Builder
 * salieron los dos de tener dos copias de la misma decisión.
 *
 * @param {{text?: string, preToolText?: string}|null} streamingMessage
 * @returns {boolean} true si la ventana debe pegarse al final.
 */
export function debeSeguirElFinal(streamingMessage) {
  if (!streamingMessage) return false;
  const hayTexto = Boolean(streamingMessage.text) || Boolean(streamingMessage.preToolText);
  return !hayTexto;
}
